import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

import {
    CustomFieldType,
    CustomFieldsEntity,
} from '../+state/custom-fields.models';

@Pipe({
    name: 'customFieldValue',
})
export class CustomFieldValuePipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(customField: CustomFieldsEntity, ...args: unknown[]): unknown {
        if (customField.value === null) {
            return '-';
        }

        if (customField.type === CustomFieldType.BOOLEAN) {
            return customField.value === true ? 'Yes' : 'No';
        }

        if (customField.type === CustomFieldType.DATE) {
            const date = moment(customField.value as string).utc();
            if (
                date.hours() === 0 &&
                date.minutes() === 0 &&
                date.seconds() === 0
            ) {
                if (!args) {
                    return date.format('L');
                }
                return date.format(args[0] as string);
            }
            return date.format(`${ args[0] || 'L' } LTS`);
        }

        return customField.value.toString();
    }
}
